// 太古商城相关接口
import request from '@/utils/request.js';
import { tg_sort_ASCII, sort_ASCII } from '@/utils';

// 获取绑定用户信息
export const bindUserInfo = (data) =>
  request({
    url: '/v1/shop/bind_user_info',
    method: 'get',
    params: {
      ...data,
      sign: tg_sort_ASCII(data),
    },
    needSToken: true,
  });

// 账号密码验证
export const accountCheck = (data) =>
  request({
    url: '/v1/shop/account_check',
    method: 'post',
    data: {
      ...data,
      sign: tg_sort_ASCII(data),
    },
    needSToken: true,
  });

// 区服角色列表
export const serverRoleOption = (data) =>
  request({
    url: '/v1/shop/server_role_option',
    method: 'post',
    data: {
      ...data,
      sign: tg_sort_ASCII(data),
    },
    needSToken: true,
  });

// 商品游戏配置分类
export const goodConfig = (data) =>
  request({
    url: '/v1/shop/good_config',
    method: 'get',
    params: {
      ...data,
      sign: tg_sort_ASCII(data),
    },
    needSToken: true,
  });

// 绑定、切换角色
export const bindRole = (data) =>
  request({
    url: '/v1/shop/bind_role',
    method: 'post',
    data: {
      ...data,
      sign: tg_sort_ASCII(data),
    },
    needSToken: true,
  });

// 购买记录
export const purchaseList = (data) =>
  request({
    url: '/v1/shop/purchase_list',
    method: 'get',
    params: {
      ...data,
      sign: tg_sort_ASCII(data),
    },
    needSToken: true,
  });

// 商品列表
export const goodsList = (data) =>
  request({
    url: '/v1/shop/goods_list',
    method: 'get',
    params: {
      ...data,
      sign: tg_sort_ASCII(data),
    },
    needSToken: true,
  });

// 点击购买进行验证
export const purchase = (data) =>
  request({
    url: '/v1/shop/purchase',
    method: 'post',
    data: {
      ...data,
      sign: tg_sort_ASCII(data),
    },
    needSToken: true,
  });

// 获取支付类型
export const payType = (data) =>
  request({
    url: '/v1/shop/pay_type',
    method: 'get',
    params: {
      ...data,
      sign: tg_sort_ASCII(data),
    },
    needSToken: true,
  });

// 创建订单
export const createOrder = (data) =>
  request({
    url: '/v1/shop/create_order',
    method: 'post',
    data: {
      ...data,
      sign: tg_sort_ASCII(data),
    },
    needSToken: true,
  });

// 埋点上报
export const shopData = (data) =>
  request({
    url: '/v1/report/shop_data',
    method: 'post',
    data: {
      ...data,
      sign: tg_sort_ASCII(data),
    },
    needSToken: true,
  });

const getEnv = function () {
  switch (window.location.hostname) {
    // 悦玩
    case 'hmtest.hzwxbz999.cn':
      return '//h5test.hzwxbz999.cn';
    case 'hmpre.hzwxbz999.cn':
      return '//h5.hzwxbz999.cn';
    default:
      return '//h5.hzwxbz3.cn';
  }
};

// 支付
export const officialAccountsPay = (data) =>
  request({
    url: `${getEnv()}/officialAccounts/pay`,
    method: 'post',
    data: sort_ASCII(data),
  });

// 检查订单
export const checkOrder = (data) =>
  request({
    url: `${getEnv()}/officialAccounts/order/show`,
    method: 'post',
    data: sort_ASCII(data),
  });

// 发送验证码
export const send_msg = (data) =>
  request({
    url: 'v1/shop/send_msg',
    method: 'post',
    data: {
      ...data,
      sign: tg_sort_ASCII(data),
    },
    needSToken: true,
  });
// 验证验证码
export const check_code = (data) =>
  request({
    url: 'v1/shop/check_code',
    method: 'post',
    data: {
      ...data,
      sign: tg_sort_ASCII(data),
    },
    needSToken: true,
  });
// 验证验证码(新) - 获取账号列表
export const check_code_list = (data) =>
  request({
    url: 'v1/shop/check_code_list',
    method: 'post',
    data: {
      ...data,
      sign: tg_sort_ASCII(data),
    },
    needSToken: true,
    showToast: true
  });
// 验证验证码(新) - 选择账号
export const choose_bind = (data) =>
  request({
    url: 'v1/shop/choose_bind',
    method: 'post',
    data: {
      ...data,
      sign: tg_sort_ASCII(data),
    },
    needSToken: true,
    showToast: true
  });

// 获取商城集合页数据
export const getCollectionData = (data) =>
  request({
    url: 'v1/shop_collection_page/info',
    method: 'get',
    params: {
      ...data,
      sign: tg_sort_ASCII(data),
    }})

export const PAY_URL = `${getEnv()}/officialAccounts/pay`;

// 检查切用户商城页是否可以访问
export const check_cut_user_auth = (data) =>
  request({
    url: 'v1/shop/check_link',
    method: 'get',
    params: {
      ...data,
      sign: tg_sort_ASCII(data),
    },
    needSToken: true,
  });
